import {
  GET_ALL_EQUIPMENT,
  GET_ALL_EQUIPMENT_SUCCESS,
  GET_ALL_EQUIPMENT_ERROR,
  GET_EQUIPMENT_TYPES,
  GET_EQUIPMENT_TYPES_SUCCESS,
  GET_EQUIPMENT_TYPES_ERROR,
  GET_EQUIPMENT_BRANDS,
  GET_EQUIPMENT_BRANDS_SUCCESS,
  GET_EQUIPMENT_BRANDS_ERROR
} from "./constants";

const initialState = {
  equipment: [],
  equipmentLoading: false,
  equipmentError: null,
  equipmentBrands: [],
  equipmentBrandsLoading: false,
  equipmentBrandsError: null,
  equipmentTypes: [],
  equipmentTypesLoading: false,
  equipmentTypesError: null,
};

function equipment(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_EQUIPMENT:
      return {
        ...state,
        equipmentLoading: false,
        equipmentError: null
      };
    case GET_ALL_EQUIPMENT_SUCCESS:
      return {
        ...state,
        equipment: payload,
        equipmentLoading: false
      };
    case GET_ALL_EQUIPMENT_ERROR:
      return {
        ...state,
        equipmentLoading: false,
        equipmentError: action.err
      };
    case GET_EQUIPMENT_TYPES:
      return {
        ...state,
        equipmentTypesLoading: false,
        equipmentTypesError: null
      };
    case GET_EQUIPMENT_TYPES_SUCCESS:
      return {
        ...state,
        equipmentTypes: payload,
        equipmentTypesLoading: false
      };
    case GET_EQUIPMENT_TYPES_ERROR:
      return {
        ...state,
        equipmentTypesLoading: false,
        equipmentTypesError: action.err
      };
    case GET_EQUIPMENT_BRANDS:
      return {
        ...state,
        equipmentBrandsLoading: false,
        equipmentBrandsError: null
      };
    case GET_EQUIPMENT_BRANDS_SUCCESS:
      return {
        ...state,
        equipmentBrands: payload,
        equipmentBrandsLoading: false
      };
    case GET_EQUIPMENT_BRANDS_ERROR:
      return {
        ...state,
        equipmentBrandsLoading: false,
        equipmentBrandsError: action.err
      };
    default:
      return state;
  }
}

export default equipment;